import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  API_ALL_NOTIFICATIONS,
  API_READ_NOTIFICATIONS,
} from "../../../config/api";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { fetchUnreadNotifications } from "./notification";
import mixpanel from "mixpanel-browser";

export const readNotifications = createAsyncThunk(
  "notifications/readNotifications",
  async ({ selected, cb }, { dispatch }) => {
    try {
      const { data } = await Client({
        method: "POST",
        path: API_READ_NOTIFICATIONS,
        data: {
          notification_ids: selected,
        },
      });
      dispatch(fetchUnreadNotifications());
      toast.success(data.message);
      // mixpanel.track("Success", {
      //   type: "Notfication",
      //   subtype: "Read-Notifications",
      // });
      cb();
      return data;
    } catch (error) {
      cb();
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {
      //   type: "Notfication",
      //   subtype: "Read-Notifications",
      //   message: msg,
      // });
      toast.error(msg);
      throw error;
    }
  }
);
